export default __webpack_public_path__ + "static/media/checkCircle.5bd82e6d.svg";